import React, { useState } from "react";
import Types from "../utils/types.json";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";

const SearchBar = ({ onChange, prodType }) => {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [sort, setSort] = useState("All");
  const { t } = useTranslation();

  const _onChange = (search, category, sort) => {
    setSearch(search);
    setCategory(category);
    setSort(sort);
    onChange(search, category, sort);
  };

  return (
    <Row className="p-2 m-0">
      <Col lg={prodType === 1 ? 6 : 8}>
        <input
          type="text"
          placeholder={t("search")}
          className="form-control bg-light border-0 mb-2 mb-lg-0"
          onChange={(e) => _onChange(e.target.value, category, sort)}
        />
      </Col>

      {prodType === 1 ? (
        <Col lg={3} className="mb-2 mb-lg-0">
          <select
            className="form-select bg-light border-0"
            onChange={(event) => _onChange(search, event.target.value, sort)}
            defaultValue="All"
          >
            <option disabled value="All">
              {t("language") === "en" ? "فلتر حسب" : "Filter by"}
            </option>
            <option value="All">{t("language") === "en" ? "الكل" : "All"}</option>
            {Types[t("language") === "en" ? "types-Ar" : "types-En"].map((type) => {
              return (
                <option key={type.id} value={type.id}>
                  {type.title}
                </option>
              );
            })}
          </select>
        </Col>
      ) : null}

      <Col lg={prodType === 1 ? 3 : 4} className="mb-2 mb-lg-0">
        <select
          className="form-select bg-light border-0"
          onChange={(event) => _onChange(search, category, event.target.value)}
          defaultValue="All"
        >
          <option disabled value="All">
            {t("language") === "en" ? "ترتيب حسب" : "Sort by"}
          </option>
          <option value="All">{t("language") === "en" ? "الكل" : "All"}</option>
          {t("language") === "en" ? (
            <>
              <option key="1" value="1">
                الأعلى سعرا
              </option>
              <option key="2" value="2">
                الأقل سعرا
              </option>
            </>
          ) : (
            <>
              <option key="1" value="1">
                Highest Price
              </option>
              <option key="2" value="2">
                Lowest Price
              </option>
            </>
          )}
        </select>
      </Col>
    </Row>
  );
};

export default SearchBar;
